import React, { useEffect } from 'react';
import './PriorityCustomers.css';

const PriorityCustomers = () => {
  useEffect(() => {
    // Load Typebot script dynamically
    const script = document.createElement('script');
    script.type = 'module';
    script.innerHTML = `
      import Typebot from 'https://cdn.jsdelivr.net/npm/@typebot.io/js@0/dist/web.js';
      Typebot.initStandard({ typebot: "mywonder-signup" });
    `;
    document.head.appendChild(script);

    // Cleanup function to remove script when component unmounts
    return () => {
      document.head.removeChild(script);
    };
  }, []);

  return (
    <div className="priority-customers-container">
      <typebot-standard style={{ height: '100vh' }}></typebot-standard>
    </div>
  );
};

export default PriorityCustomers;
